import axios from "axios";
import { buildQuery } from "utils/queryUtils";

export const findSpecializes = (headers, params) => {
    let query = buildQuery(params, ["code", "name"]);
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/specialize${query}`, {
        headers,
    });
};

export const findSpecializeById = (headers, id) => {
    return axios.get(`${process.env.REACT_APP_CATEGORY_API_URL}/specialize/${id}`, {
        headers,
    });
};
